import getEnvironment from "./getEnvironment";

export default (): boolean => {
    return getEnvironment() === "development";
};